import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CleaningMatrixService {

  constructor(
    private http : HttpClient
  ) { }

  getCleaningMatrix() {
      return (this.http.get(`${environment.apiUrl}/cleaning-matrix`));
  }
}
